import { useEffect } from 'react';
import { useEngineContext } from '@smartcharts/ui-web';

// Handles attaching the lightweight engine to the container and sequencing history+live
export default function SmartChartLifecycle() {
  const { engine, coordinator } = useEngineContext();

  useEffect(() => {
    const onInit = (e: Event) => {
      const detail = (e as CustomEvent).detail || {};
      const { container } = detail as { container: HTMLDivElement };
      if (!container || !engine) {
        console.warn('[Lifecycle] Container or engine not ready', { container: !!container, engine: !!engine });
        return;
      }
      console.log('[Lifecycle] Container ready, initializing chart...');
      try {
        // Initialize chart with container via engine.newChart
        const payload = { 
          container, 
          theme: 'light', 
          granularity: 0,
          isMobile: false,
          isLive: true,
          startWithDataFitMode: false
        };
        engine.newChart(payload);
        console.log('[Lifecycle] Chart initialized with container');
        
        // Coordinator will handle history then live after symbol selection event
        // If a last symbol exists, trigger selection to start data flow
        const last = localStorage.getItem('smartcharts.last_symbol') || 'R_100';
        console.log('[Lifecycle] Triggering initial symbol selection:', last);
        window.dispatchEvent(
          new CustomEvent('smartchart:selection', { detail: { symbol: last, granularity: 0 } })
        );
      } catch (err) {
        console.error('[Lifecycle] Error during init:', err);
      }
    };
    window.addEventListener('lightweight:init', onInit as EventListener);
    return () => window.removeEventListener('lightweight:init', onInit as EventListener);
  }, [engine, coordinator]);

  return null;
}
